import styled from '@emotion/styled';

import {textMdRegular} from '>shared/components/typography/designSystemTypography';
import {vr8} from '>styles/mixins/verticalRhythm';
import {respondTo} from '>styles/breakpoints';

export const PageContainer = styled.div`
  display: flex;

  justify-content: center;
  ${respondTo.smallOrLower} {
    padding: 0 0.8rem;
  }
`;

export const ContentContainer = styled.div`
  padding: 8rem 0;
  max-width: 64rem;
`;

export const HeadingSection = styled.div`
  display: flex;
  justify-content: space-between;
  ${vr8}
`;

export const BodyContent = styled.div`
  ${textMdRegular};
`;

export const Content = styled(BodyContent)`
  margin-bottom: 2.4rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContentSection = styled.div`
  margin-bottom: 3.2rem;
`;

export const LargeLI = styled.li`
  font-size: 1.6rem;
  margin-bottom: 2.4rem;

  ul li {
    list-style-type: disc;
  }
`;

export const ButtonContainer = styled.div`
  padding: 1.2rem 0 0 2.4rem;
`;